import {NotificationSettings} from '../../../OrderIntake/declarations/types'

export const mapFormValuesToRequestData = (toggleValue: boolean): NotificationSettings => ({
  type: 'ePod',
  option: 'immediate',
  isActive: toggleValue
})
